import React, { useState } from "react"

import { useCovalOnly } from "@/feature-flags"
import { cn, Tooltip } from "@coval/ui"
import { Laptop } from "lucide-react"

import {
  getCurrentDeployment,
  LOCAL_PIPELINE_TITLE,
} from "@/lib/local-worker-launch"
import { setDevId, useDevId } from "@/hooks/useDevId"

import { LocalWorkerDialog } from "./LocalWorkerDialog"

export const LocalWorkerIndicator: React.FC = () => {
  const isCovalOnly = useCovalOnly()
  const devId = useDevId()
  const [isOpen, setIsOpen] = useState(false)

  if (!isCovalOnly && !devId) {
    return null
  }

  const deployment = getCurrentDeployment()
  const tooltip = devId
    ? `Launches are going to the Local Pipeline matching COVAL_DEV_ID=${devId}, against ${deployment}. Click to change or clear.`
    : LOCAL_PIPELINE_TITLE

  return (
    <>
      <Tooltip side="right" content={<div className="max-w-xs">{tooltip}</div>}>
        <button
          type="button"
          onClick={() => setIsOpen(true)}
          aria-label={
            devId
              ? `Running on Local Pipeline ${devId}. Change or clear.`
              : LOCAL_PIPELINE_TITLE
          }
          data-testid="local-worker-indicator"
          className={cn(
            "flex h-[28px] w-full items-center gap-2 rounded-md px-2 transition-colors",
            devId
              ? "bg-coval-warning-surface text-coval-warning-on-surface ring-1 ring-coval-warning-border"
              : "border border-coval-border text-coval-text-muted hover:bg-surface-0-hover",
          )}
        >
          <Laptop className="h-4 w-4 shrink-0" />
          {devId ? (
            <span className="flex min-w-0 flex-1 items-baseline gap-1">
              <span className="truncate font-mono text-xs">{devId}</span>
              <span className="shrink-0 text-[10px] opacity-80">
                {deployment}
              </span>
            </span>
          ) : (
            <span className="truncate text-xs">Local Pipeline</span>
          )}
        </button>
      </Tooltip>

      {isOpen && (
        <LocalWorkerDialog
          onClose={() => setIsOpen(false)}
          devId={devId}
          onDevIdChange={setDevId}
        />
      )}
    </>
  )
}
